import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { sanitizeHtml } from '@app/shared/utils/safe-html';

@Component({
    standalone: true,
    selector: 'app-deployment-comment',
    templateUrl: './deployment-comment.component.html',
    styleUrl: './deployment-comment.component.scss',
    imports: [CommonModule]
})
export class DeploymentCommentComponent implements OnInit {
  title = '';
  popupcontent = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<any>,
    private sanitizer: DomSanitizer
  ) { }



  ngOnInit() {
    this.title = this.data.title;
    this.popupcontent = sanitizeHtml(this.sanitizer, this.data.popupcontent);
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
